module.exports = __webpack_public_path__ + "img/banco-de-nimbly.26dfba48.png";